<template>
	<footer class="footer">
		<iframe id="footer-iframe" src="https://www.dssn.com.au/events-footer/" width="" height="" scrolling="no"></iframe>
	</footer>
</template>
<script>
/* eslint-disable */
	export default {
		data() {
			return {

			}
		},
		computed: {

		},
		methods: {

		},
		mounted() {

		}
	}
</script>
<style media="screen" lang="scss">
	.footer {
		overflow: hidden;
		position: relative;
		height: 500px;
		iframe {
			width: 100%;
			overflow: hidden;
			height: 100%;
			bottom: 0;
		}
	}

</style>
